/**
 * Labstep
 *
 * @module grid/Index/coldefs/name
 * @desc Column Definition for entity name
 */

import { ICONS } from 'labstep-web/constants/icons';
import { Resource } from 'labstep-web/models/resource.model';
import { getHumanReadableEntityName } from 'labstep-web/services/i18n.service';
import { objectOrFunction } from 'labstep-web/services/react.service';
import colDefEntityLink from '../entityLink';
import type { colDefNameType } from './types';

export const COLUMN_WIDTH_NAME = 340;

export const colDefName: colDefNameType = (entityName, options?) => ({
  ...colDefEntityLink(options),
  colId: 'name',
  headerComponentParams: (params) => ({
    ...objectOrFunction(
      colDefEntityLink(options).headerComponentParams,
      params,
    ),
    icon: ICONS[entityName].primary,
    sort: 'name',
  }),
  headerName: getHumanReadableEntityName(entityName, false, true),
  width: COLUMN_WIDTH_NAME,
  lockPosition: true,
  valueGetter: (params) => {
    if (entityName === Resource.entityName) {
      return (
        params.data?.displayNameWithoutIdentifier ||
        'Untitled Resource'
      );
    }
    return params.data?.displayName || 'Untitled Resource';
  },
});

export default colDefName;
